import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

import VDealsRandom from './VDealsRandom/VDealsRandom.vue'

Vue.customElement('v-deals-random', VDealsRandom)
